import type { VideoWallTile } from './types'

export const FRONT_CAMERA_PREVIEW_NUMBER = 10
export const FRONT_CAMERA_FOCUSED_ORDER = [11, 10, 12]
export const FRONT_CAMERA_PREVIEW_HIDDEN_NUMBERS = new Set([11, 12])

export const CABIN_CAMERA_GROUPED_NUMBERS = new Set([1, 2, 3])
export const CABIN_CAMERA_FOCUSED_ORDER = [1, 2, 3]
export const CABIN_CAMERA_PREVIEW_HIDDEN_NUMBERS = new Set([2, 3])

export type CameraNameTranslations = {
  cabin: (cameraNumber: number) => string
  front: string
  frontLeft: string
  frontRight: string
  rear: string
}

const getExteriorCameraName = (
  cameraNumber: number,
  translations: CameraNameTranslations,
) => {
  switch (cameraNumber) {
    case 10:
      return translations.front
    case 11:
      return translations.frontLeft
    case 12:
      return translations.frontRight
    case 13:
      return translations.rear
    default:
      return undefined
  }
}

export const getCameraName = (
  cameraNumber: number,
  fallbackName: string,
  translations: CameraNameTranslations,
) => {
  if (cameraNumber >= 1 && cameraNumber <= 9) {
    return translations.cabin(cameraNumber)
  }

  return getExteriorCameraName(cameraNumber, translations) ?? fallbackName
}

export const getFrontCameraTiles = (tiles: VideoWallTile[]) =>
  FRONT_CAMERA_FOCUSED_ORDER.map(cameraNumber =>
    tiles.find(tile => tile.number === cameraNumber),
  ).filter((tile): tile is VideoWallTile => tile !== undefined)

export const getCabinCameraTiles = (tiles: VideoWallTile[]) =>
  CABIN_CAMERA_FOCUSED_ORDER.map(cameraNumber =>
    tiles.find(tile => tile.number === cameraNumber),
  ).filter((tile): tile is VideoWallTile => tile !== undefined)

export const getFocusedTiles = (
  focusedTile: VideoWallTile,
  tiles: VideoWallTile[],
) => {
  if (focusedTile.number === FRONT_CAMERA_PREVIEW_NUMBER) {
    return getFrontCameraTiles(tiles)
  }

  if (CABIN_CAMERA_GROUPED_NUMBERS.has(focusedTile.number)) {
    return getCabinCameraTiles(tiles)
  }

  return [focusedTile]
}
